import { useEffect, useState } from "react";
import API from "../../services/API";
import Layout from '../Frames/Layout'
import Grid from "../Tools/Grid";
import { Link } from "react-router-dom";
import Avatar from "../Tools/Avatar";
import CheckIcon from '@mui/icons-material/Check';
import UncheckIcon from '@mui/icons-material/Close';
import { MenuItem, TextField, Box, Link as A } from "@mui/material";
import moment from "moment/moment";
import CheckDate from "../Tools/CheckDate";

export default function Enrollments(){
    
    const columns = [
        {
            field: 'createdAt',
            headerName: 'Date',
            type: 'date',
            width: 90,
            aggregable: false,
            valueGetter: i => moment(i.row.createdAt).toDate(),
            renderCell: i => !i.rowNode.isAutoGenerated &&
                moment(i.value).format('DD/MM/YYYY à HH:mm')
        },
        {
            field: 'course',
            headerName: 'Formation',
            width: 400,
            aggregable: false,
            valueGetter: i => i.row.course?.title
        },
        {
            field: 'pi',
            headerName: 'P.I.',
            width: 50,
            type: 'boolean',
            aggregable: false,
            valueGetter: p => p.row.pi,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                (p.row.pi ? 
                    <CheckIcon color='primary' size='small'/> : 
                    <UncheckIcon color='error' size='small'/>)
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 190,
            aggregable: false,
            valueGetter: i => i.row.type?.title
        },
        {
            field: 'amount',
            headerName: 'Montant €',
            type: 'number',
            width: 100,
            valueGetter: i => i.row.amount || 0,
        },
        {
            field: 'avatar',
            headerName: '',
            width: 60,
            aggregable: false,
            valueGetter: i => i.row.user?.id,
            renderCell: i => !i.rowNode.isAutoGenerated &&
                <Link to={`/crm/persons/${i.row.user?.id}`}>
                    <Avatar 
                        initials={i.row.user?.initials} 
                        color={i.row.category?.color || 'grey'} 
                        size={36} 
                    />
                </Link>,
        },
        {
            field: 'user',
            headerName: 'Nom',
            width: 200,
            aggregable: false,
            valueGetter: i => i.row.user?.name
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 210,
            aggregable: false,
            valueGetter: i => i.row.user?.email,
            renderCell: i => 
                <A href={`mailto:${i.value}`}>
                    {i.value}
                </A>
        },
        {
            field: 'phone',
            headerName: 'Tél',
            width: 120,
            aggregable: false,
            valueGetter: i => i.row.user?.phone,
            renderCell: i => i.value &&
                <A href={`tel:${i.value}`}>
                    {i.value}
                </A>
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 150,
            aggregable: false,
            valueGetter: i => i.row.category?.title
        },
        {
            field: 'completion',
            headerName: 'Complétion',
            type: 'number',
            width: 100,
            valueGetter: i => i.row.completion || 0,
        },
        {
            field: 'duration',
            headerName: 'Durée',
            type: 'number',
            width: 60,
            valueGetter: i => i.row.hours || 0,
            renderCell: i => !i.rowNode.isAutoGenerated  &&
                i.value.toLocaleString() + 'h'
        },
        {
            field: 'dpc',
            headerName: 'DPC',
            width: 350,
            aggregable: false,
            valueGetter: i => i.row.dpc?.title
        },
        {
            field: 'origin',
            headerName: 'Provenance',
            width: 100,
            aggregable: false,
            valueGetter: i => i.row.origin?.title
        },
        {
            field: 'wonBy',
            headerName: 'Commercial',
            width: 150,
            aggregable: false,
            valueGetter: i => i.row.wonBy?.name
        },
        {
            field: 'cashedAt',
            headerName: 'Encaissé le',
            width: 150,
            aggregable: false,
            valueGetter: i => i.row.cashedAt,
            renderCell: i => !i.rowNode.isAutoGenerated &&
                <CheckDate 
                    label="Encaissé le :" 
                    value={i.value} 
                    onChange={date => handleChange({...i.row, cashedAt: date})}
                />
        },
    ];

    const [items, setItems] = useState(null)
    const [year, setYear] = useState(new Date().getFullYear())

    useEffect(() => {

        const year = new Date().getFullYear()

        setYear(year)

        API.get(`/crm/enrollments?year=${year}`)
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

    }, [])

    const handleYearChange = e => {

        let y = e.target.value;

        setYear(y)

        API.get(`/crm/enrollments?year=${y}`)
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

        return setItems(null);
    }

    const handleChange = item => {
        const old = [...items]

        let copy = [...items].filter(i => i.id !== item.id)
        copy.push(item)
        setItems(copy)

        API.put(`/crm/enrollments/${item.id}`, item)
            .catch(_ => setItems(old))
    }

    const years = [0, 1, 2, 3, 4].map(n => new Date().getFullYear() - n)


    return <Layout tab='enrollments' menu='crm' title='Inscriptions'>

        <Box width={150} sx={{mb: 1}}>
            <TextField
                label='Année'
                value={year}
                select
                required
                size='small'
                onChange={handleYearChange}
                fullWidth
            >
                {years.map(y => 
                    <MenuItem key={y} value={y}>{y}</MenuItem>    
                )}
            </TextField>
        </Box>
        

        <Grid 
            id='enrollmentsGrid'
            columns={columns}
            rows={items ? items.sort((a,b) => b.createdAt > a.createdAt ? 1 : -1) : null}
            toolbar
            aggregate={{amount: 'sum', completion: 'avg'}}
        />

    </Layout>

}


